<script setup>
import {computed, onMounted} from 'vue'
import {useRouter} from 'vue-router'
import {useUserStore} from '@/stores/user'
import {useTemplatesStore} from '@/stores/templates'
import Button from "./Button.vue"

const props = defineProps({
    contentTypeId: Number,
})

const router = useRouter()
const userStore = useUserStore()
const templatesStore = useTemplatesStore()

// --- Computed ---

const contentType = computed(() => {
    return templatesStore.contentTypes?.find(o => o.id === props.contentTypeId)
})

const contentTypeTitle = computed(() => {
    return contentType.value?.title
})

const contentTypeLabel = computed(() => {
    const type = contentType.value?.contentType

    // Safety check: ensure type exists before calling toLowerCase()
    if (type && type.toLowerCase() !== 'basic') {
        return type
    }

    return ''
})

const hasEditAccess = computed(() => {
    return userStore.access('templates_templates', 'edit')
})

// --- Methods ---

const gotToThemesEditor = () => {
    router.push({
        name: 'themesEditor',
        query: {
            section: 'content_types',
            id: props.contentTypeId
        }
    })
}

// --- Lifecycle ---

onMounted(() => {
    // Ensure the templates store is initialized to populate getters
    templatesStore.init()
})
</script>

<template>
    <Button
        class="btn-sm p-0 px-1"
        :disabled="!hasEditAccess"
        @click="gotToThemesEditor"
    >
        {{ contentTypeTitle }}<span v-if="contentTypeLabel"> - {{ contentTypeLabel }}</span>
    </Button>
</template>